import React, { useState, createContext, useEffect, useCallback } from "react";

export const AppStateContext = createContext();

const AppStateContextProvider = (props) => {
  const [appState, setAppState] = useState({
    menuOpen: false,
    invoiceStatuses: {},
    tab: 0,
  });

  const allTablesClosed = [0, 1, 2, 3, 4, 5, 6].reduce(
    (dayAcc, dayCur) => ({
      ...dayAcc,
      [dayCur]: false,
    }),
    {}
  );

  // [0, 1, 2, 3, 4].reduce(
  //   (weekAcc, weekCur) => ({
  //     ...weekAcc,
  //     [weekCur]: [0, 1, 2, 3, 4, 5, 6].reduce(
  //       (dayAcc, dayCur) => ({
  //         ...dayAcc,
  //         [dayCur]: false,
  //       }),
  //       {}
  //     ),
  //   }),
  //   {}
  // )

  const [tableOpen, setTableOpen] = useState(allTablesClosed);

  const [scrollOffsetY, setScrollOffsetY] = useState(undefined);

  // const getScrollPosition = () =>
  //   window.pageYOffset !== undefined
  //     ? window.pageYOffset
  //     : (document.documentElement || document.body.parentNode || document.body)
  //         .scrollTop;

  const setScrollPosition = useCallback(() => {
    const offset =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
            document.documentElement ||
            document.body.parentNode ||
            document.body
          ).scrollTop;
    console.log("setting scroll position to", offset);
    setScrollOffsetY(offset);
  }, []);

  const clearScrollPosition = useCallback(
    () => setScrollOffsetY(undefined),
    [setScrollOffsetY]
  );

  const scrollToPosition = useCallback(() => {
    if (scrollOffsetY) {
      console.log("scrolling to", scrollOffsetY);
      window.scrollTo(0, scrollOffsetY);
      // check if the scroll actually happened
      // if (getScrollPosition() === scrollOffsetY) {
      // setScrollOffsetY(undefined);
      // }
    }
  }, [scrollOffsetY]);

  const [invoiceTableFilterText, setInvoiceTableFilterText] = useState("");

  // const [loading, setLoading] = useState(true);
  // const [authenticating, setAuthenticating] = useState(true);
  // const [fetching, setFetching] = useState(false);
  // const [fetched, setFetched] = useState(false);
  const [fetch, setFetch] = useState(false);

  return (
    <AppStateContext.Provider
      value={{
        appState,
        setAppState,
        fetch,
        setFetch,
        // loading,
        // setLoading,
        // authenticating,
        // setAuthenticating,
        // fetching,
        // setFetching,
        // fetched,
        // setFetched,
        tableOpen,
        setTableOpen,
        scrollToPosition,
        setScrollPosition,
        invoiceTableFilterText,
        setInvoiceTableFilterText,
        clearScrollPosition,
      }}
    >
      {props.children}
    </AppStateContext.Provider>
  );
};

export default AppStateContextProvider;
